export default __webpack_public_path__ + "static/media/pdf 1.2bf39177.svg";